import React, { useState } from "react";

const emailRegex = new RegExp("^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$");

export default function ContactUs() {
  const [form, setForm]     = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");

  const validate = () => {
    const e = {};
    if (!form.name.trim())                  e.name    = "Name is required.";
    if (!form.email.trim())                 e.email   = "Email is required.";
    else if (!emailRegex.test(form.email))  e.email   = "Enter a valid email address.";
    if (!form.message.trim())               e.message = "Message cannot be empty.";
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setStatus("sending");
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
      setErrors({});
    } catch {
      setStatus("error");
    }
  };

  return (
    <>
      <style>{contactStyles}</style>

      <div className="ct-root">

        <div className="ct-header">
          <div>
            <span className="ct-eyebrow">Get In Touch</span>
            <h1 className="ct-title">Contact <span className="ct-title-bold">Us</span></h1>
          </div>
        </div>

        <div className="ct-rule-wrap"><hr className="ct-hr" /></div>

        <div className="ct-body">

          <div className="ct-info">
            <p className="ct-intro">
              Have a question, feedback, or collaboration idea? We'd love to hear from you.
            </p>

            <div className="ct-rule-wrap ct-rule-wrap--inner"><hr className="ct-hr" /></div>

            <div className="ct-info-block">
              <span className="ct-info-label">Email</span>
              <a href="mailto:support@veshh-eon.com" className="ct-info-value">
                support@veshh-eon.com
              </a>
            </div>

            <div className="ct-rule-wrap ct-rule-wrap--inner"><hr className="ct-hr" /></div>

            <div className="ct-info-block">
              <span className="ct-info-label">Address</span>
              <span className="ct-info-value">
                VESHH-EON Clothing<br />
                Belagavi, Karnataka, India
              </span>
            </div>

            <div className="ct-rule-wrap ct-rule-wrap--inner"><hr className="ct-hr" /></div>

            <div className="ct-info-block">
              <span className="ct-info-label">Follow Us</span>

              {/* FIXED HERE */}
              <a
                href="https://instagram.com/veshheon"
                target="_blank"
                rel="noopener noreferrer"
                className="ct-info-value ct-instagram"
              >
                @veshheon
              </a>

            </div>
          </div>

          <form onSubmit={handleSubmit} className="ct-form" noValidate>

            <div className="ct-field">
              <label className="ct-label">Full Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                className={errors.name ? "ct-input ct-input--error" : "ct-input"}
              />
              {errors.name && <span className="ct-field-error">{errors.name}</span>}
            </div>

            <div className="ct-field">
              <label className="ct-label">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                className={errors.email ? "ct-input ct-input--error" : "ct-input"}
              />
              {errors.email && <span className="ct-field-error">{errors.email}</span>}
            </div>

            <div className="ct-field">
              <label className="ct-label">Message</label>
              <textarea
                rows="5"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Tell us what's on your mind..."
                className={errors.message ? "ct-input ct-textarea ct-input--error" : "ct-input ct-textarea"}
              />
              {errors.message && <span className="ct-field-error">{errors.message}</span>}
            </div>

            <button
              type="submit"
              disabled={status === "sending"}
              className="ct-submit"
            >
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <div className="ct-success">
                <span className="ct-success-icon">&#10003;</span>
                <span className="ct-success-text">
                  Message sent — we'll get back to you soon.
                </span>
              </div>
            )}

            {status === "error" && (
              <div className="ct-success">
                <span className="ct-success-icon">&#10005;</span>
                <span className="ct-success-text">
                  Something went wrong. Please try again or email us directly.
                </span>
              </div>
            )}

          </form>
        </div>

        <div className="ct-rule-wrap"><hr className="ct-hr" /></div>
        <div className="ct-closing">
          <span className="ct-closing-text">VESHH-EON · Belagavi, Karnataka, Bharat</span>
        </div>

      </div>
    </>
  );
}

const contactStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:wght@200;300;400;500;600&display=swap');

  .ct-root {
    background: #f8f8f8;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 80px;
  }

  .ct-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px 40px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .ct-eyebrow {
    display: block;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ct-eyebrow::before {
    content: '';
    width: 24px;
    height: 1px;
    background: black;
    display: block;
    flex-shrink: 0;
  }

  .ct-title {
    font-size: clamp(32px, 4.5vw, 60px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .ct-title-bold { font-weight: 600; }

  .ct-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .ct-rule-wrap--inner {
    padding: 0;
  }
  .ct-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  .ct-body {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px;
    display: grid;
    grid-template-columns: 1fr 1.4fr;
    gap: 80px;
    align-items: start;
  }

  .ct-info {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .ct-intro {
    font-size: 14px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.04em;
    margin-bottom: 28px;
  }

  .ct-info-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 22px 0;
  }

  .ct-info-label {
    font-size: 8px;
    font-weight: 500;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
  }

  .ct-info-value {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.08em;
    color: #000;
    text-decoration: none;
    line-height: 1.7;
  }

  .ct-instagram {
    position: relative;
    display: inline-block;
    padding-bottom: 3px;
  }
  .ct-instagram::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 100%;
    height: 1px;
    background: black;
    transition: background 0.25s ease;
  }
  .ct-instagram:hover::after { background: #000; }

  .ct-form {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  .ct-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .ct-label {
    font-size: 8px;
    font-weight: 500;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
  }

  .ct-input {
    background: transparent;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,0.15);
    outline: none;
    font-family: 'Exo 2', sans-serif;
    font-size: 13px;
    font-weight: 300;
    letter-spacing: 0.06em;
    color: #000;
    padding: 10px 0;
    width: 100%;
    transition: border-color 0.2s ease;
    border-radius: 0;
    -webkit-appearance: none;
  }
  .ct-input::placeholder {
    color: black;
    font-weight: 300;
  }
  .ct-input:focus { border-bottom-color: #000; }
  .ct-input--error { border-bottom-color: #cc0000; }

  .ct-field-error {
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #cc0000;
  }

  .ct-textarea {
    resize: none;
    line-height: 1.8;
  }

  .ct-submit {
    width: 100%;
    background: #000;
    color: #fff;
    border: none;
    font-family: 'Exo 2', sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    padding: 16px;
    cursor: pointer;
    transition: background 0.2s ease;
    margin-top: 4px;
  }
  .ct-submit:hover:not(:disabled) { background: #222; }
  .ct-submit:disabled { opacity: 0.5; cursor: not-allowed; }

  .ct-success {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid black;
  }

  .ct-success-icon {
    font-size: 12px;
    font-weight: 600;
    color: #000;
    flex-shrink: 0;
  }

  .ct-success-text {
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: black;
  }

  .ct-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 28px 80px 0;
    text-align: center;
  }

  .ct-closing-text {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    color: black;
  }

  @media (max-width: 1024px) {
    .ct-header  { padding: 48px 40px 32px; }
    .ct-rule-wrap { padding: 0 40px; }
    .ct-body    { padding: 48px 40px; gap: 48px; }
    .ct-closing { padding: 24px 40px 0; }
  }

  @media (max-width: 768px) {
    .ct-header  { padding: 40px 20px 28px; }
    .ct-rule-wrap { padding: 0 20px; }
    .ct-body {
      padding: 40px 20px;
      grid-template-columns: 1fr;
      gap: 48px;
    }
    .ct-closing { padding: 24px 20px 0; }
  }

  @media (max-width: 360px) {
    .ct-header  { padding: 32px 14px 24px; }
    .ct-rule-wrap { padding: 0 14px; }
    .ct-body    { padding: 32px 14px; }
    .ct-closing { padding: 20px 14px 0; }
  }
`;
